import { Navigate, Route, Routes } from "react-router-dom";
import { NavigationRoutes } from "./NavigationRoutes";
import AppLayout from "../layout/AuthLayout/AuthLayout";

import {
  Dashboard,
  ProfileManagement,
  SubscriptionManagement,
  UserDetails,
  UserManagement,
} from "./LazyImports";

import useAuthStore from "@Store/authStore";
import { useEffect } from "react";

const authRoutes = [
  {
    title: "Dashboard",
    path: NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD,
    component: <Dashboard />,
  },
  {
    title: "UserManagement",
    path: NavigationRoutes.DASHBOARD_ROUTES.USER_MANAGEMENT,
    component: <UserManagement />,
  },

  {
    title: "UserDetails",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.USER_DETAILS}/:id/`,
    component: <UserDetails />,
  },

  {
    title: "Profile",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.PROFILE_MANAGEMENT}`,
    component: <ProfileManagement />,
  },
  {
    title: "Subscription",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.SUBSCRIPTION}`,
    component: <SubscriptionManagement />,
  },
];

const Authenticated = () => {
  const { isAuth } = useAuthStore();
  const NAVIGATE_TO = isAuth
    ? NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD
    : NavigationRoutes.AUTH_ROUTES.LOGIN;

  useEffect(() => {
    document.title = "Dashboard - Story Tree";
  }, []);

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {authRoutes.map(({ path, component }, index) => {
          return <Route key={index} path={path} element={component} />;
        })}
      </Route>
      <Route path="*" element={<Navigate to={NAVIGATE_TO} />} />
    </Routes>
  );
};

export default Authenticated;
